import intermind, { Command, ToggleCommandParticipant } from '../../../index';

const ENDPOINT: Record<Command, string> = {
  slower: 'request-slower',
  stop: 'request-stop',
  repeat: 'request-repeat',
  'usual-talk': 'request-usual-talk',
} as const;

export class CommandsResource {
  private buildUrl(conferenceId: string, endpoint: string) {
    return `/conferences/${conferenceId}/${endpoint}`;
  }

  async getCommand(commandType: Command, conferenceId: string) {
    const endpoint = ENDPOINT[commandType];
    if (!endpoint) throw new Error(`Unknown command: ${commandType}`);

    const url = this.buildUrl(conferenceId, endpoint);
    return await intermind.httpClient.get<ToggleCommandParticipant[]>(url);
  }

  async update({
    commandType,
    conferenceId,
    participantId,
    isRaised,
  }: {
    commandType: Command;
    conferenceId: string;
    participantId: string;
    isRaised: boolean;
  }): Promise<void> {
    const endpoint = ENDPOINT[commandType];
    if (!endpoint) throw new Error(`Unknown command: ${commandType}`);

    const baseUrl = this.buildUrl(conferenceId, endpoint);

    try {
      if (isRaised) {
        await intermind.httpClient.post(baseUrl, { participantId });
      } else {
        await intermind.httpClient.delete(`${baseUrl}/${participantId}`);
      }
    } catch (err) {
      console.error(
        `Failed to update command="${commandType}" conference="${conferenceId}" participant="${participantId}"`,
        err
      );
    }
  }
}
